import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Error } from '@infl-ts/ui-advocate-components';
import { MemoizedUnknownBlockList } from '@infl-ts/ui-blocks';
import { wrapIntoFragment } from '@infl-ts/ui-wrap-into-fragment';
import { logQueryError } from '@infl-ts/util-query-errors';
import { Box } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { flow, pipe } from 'fp-ts/function';
import { jsx as _jsx } from "react/jsx-runtime";

var PageBlockList = function PageBlockList(_ref) {
  var siteConfig = _ref.siteConfig,
      leafBlocks = _ref.leafBlocks,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? wrapIntoFragment : _ref$children;
  return pipe(siteConfig, DE.squash(function () {
    return /*#__PURE__*/_jsx(Box, {});
  }, flow(logQueryError, function () {
    return /*#__PURE__*/_jsx(Error, {
      showReloadPage: true,
      headerSize: "h3"
    });
  }), function (props) {
    return /*#__PURE__*/_jsx(MemoizedUnknownBlockList, _objectSpread(_objectSpread({}, props), {}, {
      leafBlocks: leafBlocks
    }));
  }), children);
};

export default PageBlockList;